import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Divider, Paper, CircularProgress, Alert } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import DOMPurify from 'dompurify';
import apiService from '../../services/apiService';
import { API_ENDPOINTS } from '../../config/api';

const LegalDocumentView = ({ type, title }) => {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setDocument(null);
    setLoading(true);
    apiService.get(API_ENDPOINTS.LEGAL.CURRENT(type))
      .then((response) => setDocument(response.data.document))
      .catch(() => setError('A dokumentum jelenleg nem elérhető.'))
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <>
      <Helmet>
        <title>{title} – Wedigo</title>
      </Helmet>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            {title}
          </Typography>
          {document && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Hatályos: {new Date(document.effectiveAt).toLocaleDateString('hu-HU')}
            </Typography>
          )}

          <Divider sx={{ mb: 5 }} />

          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress />
            </Box>
          )}
          {error && <Alert severity="error">{error}</Alert>}
          {document && (
            <Typography
              component="div"
              sx={{
                lineHeight: 1.9,
                color: 'text.secondary',
                '& h2': { fontSize: '1.25rem', fontWeight: 700, color: 'primary.main', mt: 4, mb: 1.5 },
                '& h3': { fontSize: '1.05rem', fontWeight: 700, color: 'text.primary', mt: 3, mb: 1 },
                '& p': { mb: 1.5 },
                '& ul': { pl: 3, mb: 1.5 },
                '& a': { color: 'primary.main' },
              }}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(document.content) }}
            />
          )}
        </Paper>
      </Container>
    </>
  );
};

export default LegalDocumentView;
